import { render } from "./securityoverride.vue?vue&type=template&id=4e03a1d3"
import script from "./securityoverride.vue?vue&type=script&lang=js"
export * from "./securityoverride.vue?vue&type=script&lang=js"

import "./securityoverride.vue?vue&type=style&index=0&id=4e03a1d3&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__